// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"797":"8f8cf311","855":"b80daa3a"}[chunkId] + ".chunk.css";
};